import { FieldsPaneBucket } from "./field-bucket.component";

export * from "./field-bucket.component";
export default FieldsPaneBucket;

FieldsPaneBucket.define("fields-pane-bucket");

declare global {
    interface HTMLElementTagNameMap {
        "fields-pane-bucket": FieldsPaneBucket;
    }
}
